<template>
  <div class="assetCatalogue h-full">
    <div class="content h-full">
      <el-row :gutter="10" class="h-full">
        <el-col :span="5" class="h-full" id="leftCol">
          <el-card
            v-loading="loading"
            class="h-full"
            :body-style="{ padding: '20px', height: '100%', position: 'relative' }"
          >
            <el-row class="flex">
              <el-input
                :placeholder="$t('pleaseEnter')"
                v-model="keyWord"
                clearable
                @keyup.enter.native="getTreeKinds('refrech')"
              ></el-input>
              <el-button type="primary" class="ml-10px" @click="getTreeKinds('refrech')">{{
                $t('search')
              }}</el-button>
            </el-row>
            <el-row class="flex mt-10px">
              <div class="flex-1 title leading-36px text-14px font-bold" style="line-height: 36px">
                <el-checkbox v-model="checked" @change="checkAll" class="!mr-5px"></el-checkbox
                >{{ $t('assetCatalogTree') }}
              </div>
              <el-button :disabled="!$hasAccess('create')" type="primary" @click="addTreeItem">{{
                $t('create')
              }}</el-button>
              <el-button :disabled="!$hasAccess('delete')" type="danger" @click="deleteTree">{{
                $t('delete')
              }}</el-button>
            </el-row>
            <el-row class="mt-10px" style="height: calc(100% - 92px)">
              <div
                v-for="(item, index) in editableTabs"
                :key="index"
                class="text-14px h-30px !leading-30px"
                :class="currentTreeId === item.id ? 'active' : ''"
                style="line-height: 36px"
                v-show="editableTabs.length"
              >
                <div class="flex">
                  <el-checkbox
                    v-model="item.checked"
                    class="!mr-5px"
                    @change="checkOne"
                  ></el-checkbox>
                  <el-tooltip :content="item.name" :open-delay="500" placement="top">
                    <div @click.stop="clickItem(item)" class="flex-1 text-overflow">
                      {{ item.name }}
                    </div>
                  </el-tooltip>
                </div>
              </div>
              <div v-show="!editableTabs.length" class="h-full flex-center">
                {{ $t('noDataYet') }}
              </div>
            </el-row>
            <!-- <el-tabs
              type="border-card"
              class="treeTabs h-full"
              v-model="currentTreeId"
              v-if="editableTabs.length"
            >
              <el-tab-pane
                :label="item.name"
                :name="item.id"
                v-for="(item, index) in editableTabs"
                :key="index"
              >
              </el-tab-pane>
            </el-tabs>
            <div v-else>暂无数据</div> -->
            <div class="toLeft" v-if="showLeft" @click="isShowLeft">
              <i class="iconfont icon-bg-circleLeft text-30px"></i>
            </div>
          </el-card>
        </el-col>
        <el-col :span="5" class="h-full">
          <el-card
            v-loading="treeLoading"
            class="h-full"
            :body-style="{ padding: '20px', height: 'calc(100% - 45px)', position: 'relative' }"
          >
            <div slot="header">
              <div class="text-center">{{ currentTreeName }}</div>
            </div>
            <!-- 资产目录配置，flag=1不展示目录树 -->
            <div class="w-full h-full" id="tree" v-if="currentConfig && currentConfig.flag !== 1">
              <VirtualTree
                :highlight-current="true"
                :data="treeData"
                :props="defaultProps"
                :treeStyle="{
                  maxHeight: heightObj.maxHeight,
                  minHeight: heightObj.minHeight,
                  overflowY: 'auto',
                }"
                class="w-full"
                emptyText="暂无数据"
                accordion
                :expand-on-click-node="false"
                lazy
                :load="loadNode"
              >
                <div
                  class="custom-tree-node text-overflow w-full d-flex flex-align-center"
                  slot-scope="{ node, data }"
                >
                  <el-tooltip :content="data.name" placement="top" :disabled="isShowTooltip">
                    <span
                      class="text-overflow tree-text-label fz-12"
                      @mousemove="onMouseOver(`treeTooltip${node.id}`)"
                      :class="`treeTooltip${node.id}`"
                      >{{ data.name }}</span
                    >
                  </el-tooltip>
                </div>
              </VirtualTree>
            </div>
            <div class="toRight" v-if="!showLeft" @click="isShowLeft">
              <i class="iconfont icon-bg-circleRight text-30px"></i>
            </div>
          </el-card>
        </el-col>
        <el-col :span="14" class="h-full" id="rightCol">
          <div class="h-full w-full">
            <el-card
              class="h-full"
              :body-style="{ padding: '20px', height: '100%', overflow: 'auto' }"
            >
              <el-row class="h-36px w-full">
                <div class="flex float-right">
                  <!-- <el-button :disabled="!$hasAccess('create')" type="primary" @click="addTreeItem">{{
                  $t('create')
                }}</el-button> -->
                  <!-- <el-button :disabled="!$hasAccess('delete')" type="danger" @click="deleteTree">{{
                  $t('delete')
                }}</el-button> -->
                  <el-switch
                    v-model="assetForm.flag"
                    class="ml-10px h-36px"
                    active-value="0"
                    inactive-value="1"
                    :active-text="$t('启用')"
                    :inactive-text="$t('停用')"
                  ></el-switch>
                  <el-button
                    :disabled="!$hasAccess('save')"
                    type="primary"
                    @click="saveTreeTab"
                    class="ml-10px"
                    :loading="saveTreeTabLoading"
                    >{{ $t('save') }}</el-button
                  >
                </div>
              </el-row>
              <div style="width: 100%">
                <el-form :model="assetForm" ref="assetForm" :rules="assetRules" label-width="100px">
                  <el-row
                    :gutter="10"
                    type="flex"
                    align="middle"
                    class="mt-20px"
                    justify="space-between"
                  >
                    <el-col :span="12">
                      <el-form-item :label="$t('编码')" prop="code">
                        <el-input
                          v-model="assetForm.code"
                          clearable
                          :placeholder="$t('资产数据维度编码')"
                          auto-complete="off"
                        ></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item :label="$t('name')" prop="name">
                        <el-input
                          v-model="assetForm.name"
                          clearable
                          :placeholder="$t('资产数据维度名称')"
                          auto-complete="off"
                        ></el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row :gutter="10" type="flex" align="middle">
                    <el-col :span="12">
                      <el-form-item :label="$t('标准')" prop="standardId">
                        <el-select
                          style="width: 100%"
                          clearable
                          v-model="assetForm.standardId"
                          :placeholder="$t('pleaseSelect')"
                          @change="standardChange"
                        >
                          <el-option
                            v-for="item in standardOptions"
                            :key="item.id"
                            :label="item.name"
                            :value="item.id"
                          ></el-option>
                        </el-select>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item :label="$t('whetherItIsMasterDataOrNot')">
                        <div class="flex">
                          <el-checkbox
                            v-model="assetForm.isMainData"
                            class="!mr-10px"
                          ></el-checkbox>
                          <el-select
                            class="flex-1"
                            clearable
                            v-model="assetForm.dataMainTypeId"
                            v-if="assetForm.isMainData"
                            :placeholder="$t('pleaseSelectMasterDataType')"
                            @change="dataKindChange"
                          >
                            <el-option
                              v-for="(item, index) in mainDataList"
                              :key="index"
                              :label="item.typeName"
                              :value="item.id"
                            ></el-option>
                          </el-select>
                        </div>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <!-- <el-row :gutter="10" type="flex" align="middle">
                    <el-col :span="12">
                      <el-form-item label="类别类型" prop="classTypeId">
                        <el-select
                          style="width: 100%"
                          clearable
                          v-model="assetForm.classTypeId"
                          :placeholder="$t('pleaseSelect')"
                        >
                          <el-option
                            v-for="(item, index) in typeClassList"
                            :key="index"
                            :label="item.name"
                            :value="item.id"
                          ></el-option>
                        </el-select>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item :label="$t('实体')" prop="classId">
                        <el-select
                          style="width: 100%"
                          clearable
                          filterable
                          :disabled="isDisabled"
                          v-model="assetForm.classId"
                          :placeholder="$t('pleaseSelect')"
                          @change="classChange"
                        >
                          <el-option
                            v-for="item in entityOptions"
                            :key="item.id"
                            :label="item.name"
                            :value="item.id"
                          ></el-option>
                        </el-select>
                      </el-form-item>
                    </el-col>
                  </el-row> -->
                  <el-row :gutter="10" type="flex" align="middle">
                    <el-col :span="12">
                      <el-form-item :label="$t('序号')" prop="seqNo">
                        <el-input
                          v-model.number="assetForm.seqNo"
                          :placeholder="$t('序号')"
                          maxlength="9"
                          auto-complete="off"
                          clearable
                        ></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item :label="$t('displayStandardName')">
                        <el-checkbox v-model="assetForm.isDisplayStandardName"></el-checkbox>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="24">
                      <el-form-item :label="$t('描述')" prop="remark">
                        <el-input
                          v-model="assetForm.remark"
                          clearable
                          :placeholder="$t('资产数据维度描述')"
                          auto-complete="off"
                        ></el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row :gutter="10" type="flex" align="middle" justify="space-between">
                    <el-col :span="12">
                      <el-form-item
                        :label="$t('filterDataLabels')"
                        prop="isDataLabel"
                        label-width="120px"
                      >
                        <div class="flex">
                          <el-checkbox
                            v-model="assetForm.isDataLabel"
                            class="!mr-10px"
                          ></el-checkbox>
                          <el-select
                            class="flex-1"
                            clearable
                            filterable
                            v-if="assetForm.isDataLabel"
                            v-model="assetForm.dataLabelId"
                            :placeholder="$t('pleaseSelect')"
                          >
                            <el-option
                              v-for="item in dataLabelOptions"
                              :key="item.id"
                              :label="item.name"
                              :value="item.id"
                            ></el-option>
                          </el-select>
                        </div>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item
                        :label="$t('filterEntityCollection')"
                        prop="isNotionalpooling"
                        label-width="120px"
                      >
                        <div class="flex">
                          <el-checkbox
                            v-model="assetForm.isNotionalpooling"
                            class="!mr-10px"
                          ></el-checkbox>
                          <el-select
                            class="flex-1"
                            clearable
                            filterable
                            v-if="assetForm.isNotionalpooling"
                            v-model="assetForm.classNotionalpoolingId"
                            :placeholder="$t('pleaseSelect')"
                          >
                            <el-option
                              v-for="item in classNotionalpoolingOPtions"
                              :key="item.id"
                              :label="item.name"
                              :value="item.id"
                            ></el-option>
                          </el-select>
                        </div>
                      </el-form-item>
                    </el-col>
                  </el-row>
                </el-form>
              </div>
              <!-- <el-table
                class="asset_table"
                :data="tableData"
                stripe
                border
                v-loading="isLoadTable"
                height="calc(100% - 360px)"
              >
                <el-table-column :label="$t('序号')" width="70" type="index"></el-table-column>
                <el-table-column :label="$t('展开属性')">
                  <template slot-scope="scope">
                    <el-select
                      class="w-full"
                      clearable
                      v-model="scope.row.breakdownClassattributeId"
                      :placeholder="$t('pleaseSelect')"
                      @change="changeOpenAtrrs(scope.row.breakdownClassattributeId, scope.row)"
                    >
                      <el-option
                        v-for="item in openAtrrOptions"
                        :key="item.id"
                        :label="item.name"
                        :value="item.id"
                      ></el-option>
                    </el-select>
                  </template>
                </el-table-column>
                <el-table-column :label="$t('引用实体')">
                  <template slot-scope="scope">
                    <el-input
                      class="w-full"
                      disabled
                      v-model="scope.row.referenceClassName"
                    ></el-input>
                  </template>
                </el-table-column>
                <el-table-column :label="$t('显示属性')">
                  <template slot-scope="scope">
                    <el-select
                      class="w-full"
                      clearable
                      v-model="scope.row.displayClassattributeId"
                      :placeholder="$t('pleaseSelect')"
                    >
                      <el-option
                        v-for="item in scope.row.displayClassAttributeList"
                        :key="item.id"
                        :label="item.name"
                        :value="item.id"
                      ></el-option>
                    </el-select>
                  </template>
                </el-table-column>
                <el-table-column :label="$t('是否递归展示')" width="140" class-name="cell-center">
                  <template slot-scope="scope">
                    <div class="tc">
                      <el-checkbox v-model="scope.row.withhierarchy"></el-checkbox>
                    </div>
                  </template>
                </el-table-column>
                <el-table-column :label="$t('层级')" sortable width="220">
                  <template slot-scope="scope">
                    <el-input-number
                      v-model="scope.row.seqNo"
                      :min="1"
                      :max="10"
                      :label="$t('描述文字')"
                    ></el-input-number>
                  </template>
                </el-table-column>
                <el-table-column :label="$t('操作')" width="180">
                  <template slot-scope="scope">
                    <el-button
                      :disabled="!$hasAccess('create')"
                      size="mini"
                      @click="handleAdd(scope.$index, scope.row)"
                      >{{ $t('create') }}</el-button
                    >
                    <el-button
                      :disabled="!$hasAccess('delete')"
                      size="mini"
                      @click="handleDelete(scope.$index, scope.row)"
                      >{{ $t('delete') }}</el-button
                    >
                  </template>
                </el-table-column>
              </el-table> -->
              <div class="h-[calc(100%-306px)]">
                <div class="mb-10px">
                  <el-tooltip placement="top">
                    <div slot="content">
                      注意：<br />1、整个目录只有其中一个目录能开启“按类型展开”。<br />2、整个目录只有其中一个目录能开启“是否递归”。<br />3、“是否递归”数据只能针对上级属性，且上级是引用自身的实体。<br />4、开启递归后，下级必须填写“映射上级实体”，实现不同实体形成目录树。<br />5、同一级目录内同一个实体只能配置一个。
                    </div>
                    <i class="iconfont icon-line-circleQuestion"></i>
                  </el-tooltip>
                  <span class="ml-10px mr-10px">{{ $t('directoryTreeConfiguration') }}</span>
                  <el-button
                    type="primary"
                    :disabled="!$hasAccess('add')"
                    @click="addHierarchies"
                    >{{ $t('addHierarchies') }}</el-button
                  >
                  <!-- <el-button type="primary" :disabled="!$hasAccess('import')">导入</el-button>
                  <el-button type="primary" :disabled="!$hasAccess('export')">导出</el-button> -->
                  <el-button
                    type="danger"
                    :disabled="!$hasAccess('delete')"
                    @click="batchDelHierarchies"
                    >{{ $t('delete') }}</el-button
                  >
                </div>
                <el-collapse v-model="activeNames">
                  <el-collapse-item
                    v-for="(item, index) in directoryConfigData"
                    :key="index"
                    :name="index"
                  >
                    <template slot="title">
                      <div class="w-full">
                        <div class="float-left">
                          <el-checkbox class="pr-5px" v-model="item.checked"></el-checkbox>
                          {{ $t('directory') }}
                          <span class="text-16px text-bold">{{ index + 1 }}</span>
                          <!-- <el-input-number
                            class="ml-10px"
                            v-model="item.seqNo"
                            size="mini"
                          ></el-input-number> -->
                        </div>
                        <div class="float-right">
                          <el-button
                            size="mini"
                            :disabled="!$hasAccess('create')"
                            @click.native.stop="addProperties(index)"
                            >{{ $t('create') }}</el-button
                          >
                          <el-button
                            v-if="index !== 0"
                            size="mini"
                            :disabled="!$hasAccess('delete')"
                            @click.native.stop="delHierarchies(index)"
                            >{{ $t('delete') }}</el-button
                          >
                          <!-- 按实体展开,所有层级只能选择一次 -->
                          <span class="mx-10px" @click.stop>
                            {{ $t('expandByEntity') }}
                            <el-switch
                              v-model="item.isByClassType"
                              @change="changeIsByClassType(index, item.isByClassType)"
                            ></el-switch>
                          </span>
                          <!-- 只有第一级才能选择是否递归 -->
                          <span v-if="index === 0" class="mr-10px" @click.stop>
                            {{ $t('recursiveOrNot') }}
                            <el-switch v-model="item.withhierarchy"></el-switch>
                          </span>
                          <div v-else class="w-98px inline-block"></div>
                        </div>
                      </div>
                    </template>
                    <el-table class="asset_table" :data="item.tableData" border>
                      <el-table-column type="selection" width="55"></el-table-column>
                      <el-table-column
                        :label="$t('序号')"
                        width="70"
                        type="index"
                      ></el-table-column>
                      <el-table-column :label="`*${$t('Class')}`" prop="index">
                        <template slot-scope="scope">
                          <el-select
                            v-model="scope.row.classId"
                            clearable
                            filterable
                            size="small"
                            :placeholder="$t('pleaseSelect')"
                            @change="changeClassId(scope.row, index, scope.$index, true)"
                          >
                            <el-option
                              v-for="item in scope.row.classList"
                              :key="item.id"
                              :label="item.name"
                              :value="item.id"
                              :disabled="item.disabled"
                            ></el-option
                          ></el-select>
                        </template>
                      </el-table-column>
                      <el-table-column :label="$t('characteristicAttributes')" prop="index">
                        <template slot-scope="scope">
                          <el-select
                            v-model="scope.row.breakdownClassattributeId"
                            clearable
                            filterable
                            size="small"
                            :placeholder="$t('pleaseSelect')"
                            @change="changeOpenAtrrs(scope.row, index, scope.$index)"
                          >
                            <el-option
                              v-for="item in scope.row.attributeList"
                              :key="item.id"
                              :label="item.name"
                              :value="item.id"
                            ></el-option>
                          </el-select>
                        </template>
                      </el-table-column>
                      <el-table-column
                        :label="$t('引用实体')"
                        prop="referenceClassName"
                      ></el-table-column>
                      <el-table-column :label="$t('显示属性')" prop="index">
                        <template slot-scope="scope">
                          <el-select
                            v-model="scope.row.displayClassattributeId"
                            clearable
                            filterable
                            size="small"
                            :placeholder="$t('pleaseSelect')"
                          >
                            <el-option
                              v-for="item in scope.row.displayClassAttributeList"
                              :key="item.id"
                              :label="item.name"
                              :value="item.id"
                            ></el-option>
                          </el-select>
                        </template>
                      </el-table-column>
                      <el-table-column :label="$t('associationProperties')" prop="index">
                        <template slot-scope="scope">
                          <el-select
                            v-model="scope.row.relevancyClassAttributeId"
                            clearable
                            filterable
                            size="small"
                            :placeholder="$t('pleaseSelect')"
                            :disabled="index === 0 || scope.row.relationDisabled"
                          >
                            <el-option
                              v-for="item in scope.row.attributeList"
                              :key="item.id"
                              :label="item.name"
                              :value="item.id"
                            ></el-option>
                          </el-select>
                        </template>
                      </el-table-column>
                      <el-table-column :label="$t('associateTheParentEntity')" prop="index">
                        <template slot-scope="scope">
                          <el-select
                            v-model="scope.row.mapParentClassId"
                            clearable
                            filterable
                            size="small"
                            :placeholder="$t('pleaseSelect')"
                            :disabled="index === 0 || scope.row.relationDisabled"
                          >
                            <el-option
                              v-for="item in scope.row.mapParentClassList"
                              :key="item.id"
                              :label="item.name"
                              :value="item.id"
                            ></el-option>
                          </el-select>
                        </template>
                      </el-table-column>
                      <el-table-column :label="$t('operate')" width="160">
                        <template slot-scope="scope">
                          <el-button
                            :disabled="!$hasAccess('create')"
                            size="mini"
                            @click="handleAdd(index, scope.$index)"
                            >{{ $t('create') }}</el-button
                          >
                          <el-button
                            :disabled="!$hasAccess('delete')"
                            size="mini"
                            @click="handleDelete(index, scope.$index)"
                            >{{ $t('delete') }}</el-button
                          >
                        </template>
                      </el-table-column>
                    </el-table>
                  </el-collapse-item>
                </el-collapse>
              </div>
            </el-card>
          </div>
        </el-col>
      </el-row>
    </div>

    <!-- 展开属性对话框 -->
    <ExpandProperties :dialogForm="dialogForm" @updateSelect="updateSelect" />
  </div>
</template>

<script>
import MasterDataManageService from '@/services/masterDataManageService'
import StdClassTypeService from '@/services/bsApi/StdClassTypeService'
import assetService from '@/services/assetService'
import dataLabelManagementService from '@/services/dataLabelManagementService'
import VirtualTree from '@/components/virtualScrollTree/tree'
import ExpandProperties from './components/ExpandProperties'

export default {
  components: {
    VirtualTree,
    ExpandProperties,
  },
  data() {
    return {
      dialogForm: {
        visiable: false,
        standardId: '',
        ids: [],
      },
      activeNames: [0], // 当前展开的面板
      directoryConfigData: [
        {
          seqNo: 1,
          checked: false,
          isByClassType: false, // 按类型展开
          withhierarchy: false, // 是否递归
          tableData: [
            {
              id: 1,
              classId: '', // 实体
              classList: [], // 实体列表
              breakdownClassattributeId: '', // 属性
              attributeList: [], // 属性列表
              referenceClassName: '', // 引用实体
              referenceClassId: '',
              displayClassattributeId: '', // 显示属性
              relevancyClassAttributeId: '', // 关联属性
              mapParentClassId: '', // 关联上级实体
              mapParentClassList: [], // 关联上级实体列表
            },
          ],
        },
      ], // 目录树配置
      treeData: [], // 资产树数据
      treeLoading: false, // 是否加载tree中
      isDisabled: true, // 实体下拉是否禁用
      // 当前tab切换树种类的id
      currentTreeId: '',
      editableTabs: [],
      defaultProps: {
        children: 'children',
        label: 'name',
        isLeaf: 'isLeaf',
      },
      input: '',
      assetRules: {},
      assetForm: {
        code: '',
        name: '',
        id: '',
        standardId: '',
        classId: '',
        dataLabelId: '',
        isDataLabel: false,
        classNotionalpoolingId: '',
        isNotionalpooling: false,
        remark: '',
        structureBreakdownDetails: [],
        flag: '0',
        seqNo: '',
        dataKind: 0, // 数据种类
        classTypeId: '', // 类别类型
        isMainData: false, // 是否主数据
        dataMainTypeId: '', // 主数据类型
        isDisplayStandardName: true, // 是否显示标准名称
      },
      standardOptions: [], // 标准下拉列表
      entityOptions: [], // 实体下拉列表
      dataLabelOptions: [], // 数据标签下拉列表
      classNotionalpoolingOPtions: [], // 实体归集下拉列表
      openAtrrOptions: [], // 展开属性下拉列表
      tableData: [], // tree层级编辑新增table
      isAddOpr: false, // 是否是新增操作
      isLoadTable: false, // 层级table的加载状态
      pageNo: 1,
      pageSize: 100,
      heightObj: {
        minHeight: '30rem',
        maxHeight: '45rem',
        isZoom: false,
      },
      currentTreeName: '',
      checked: false,
      showLeft: true,
      loading: false,
      keyWord: '',
      dataKindList: [],
      typeClassList: [],
      currentIndex: 0,
      currentConfig: {},
      isShowTooltip: false,
      attributeObj: { 1: [] }, // 数据反显将属性列表按照键值对存储起来
      classIdList: [],
      mainDataList: [], // 主数据下拉框
      saveTreeTabLoading: false,
    }
  },
  async created() {
    // 解决this.$t报错问题
    this.assetRules = {
      seqNo: [
        {
          required: true,
          message: this.$t('pleaseEnterTheSeqNo'),
          trigger: 'blur',
        },
        { type: 'number', message: '只能输入数字', trigger: 'blur' },
      ],
      code: [
        {
          required: true,
          message: this.$t('PleaseEnterCode'),
          trigger: 'change',
        },
      ],
      name: [
        {
          required: true,
          message: this.$t('pleaseEnterTheName'),
          trigger: 'change',
        },
      ],
      standardId: [
        {
          required: true,
          message: this.$t('pleaseSelectAstandard'),
          trigger: 'change',
        },
      ],
      classId: [
        {
          required: true,
          message: this.$t('pleaseSelectClass'),
          trigger: 'change',
        },
      ],
      dataKind: [
        {
          required: true,
          message: this.$t('pleaseSelectDataType'),
          trigger: 'change',
        },
      ],
    }
    await this.getDataKind()
    await this.getMainDataType()
    this.getTreeKinds('refrech')
    this.getStdStandardList()
    this.getDataLabelList()
    this.getClassNotionalpoolingList()
  },
  mounted() {
    this.attributeObj = Object.assign({}, this.attributeObj)
  },
  methods: {
    // 获取主数据类型
    async getMainDataType() {
      const res = await MasterDataManageService.getList({
        SkipCount: 0,
        MaxResultCount: 999,
        Sorting: '',
      })
      if (res && res.code === 0) {
        this.mainDataList = res.data
      }
    },
    // 当选择数据种类为主数据时，下拉查询列表的接口 只能选择是主数据的实体
    dataKindChange(val) {
      if (val) {
        this.getClassList(true, val)
        this.assetForm.dataKind = 2
      } else {
        this.getClassList()
        this.assetForm.dataKind = 0
      }
      // const dataOne = _.filter(this.dataKindList, (item) => {
      //   return item.item1 === val
      // })
      // if (dataOne.length && dataOne[0].item2 === '主数据') {
      //   this.getClassList(true)
      // } else {
      //   this.getClassList(false)
      // }
    },
    // 当选择数据种类为主数据时，下拉查询列表的接口 只能选择是主数据的实体
    // 鼠标移入，文字长度溢出，显示tooltip
    onMouseOver(node) {
      const offsetWidth = document.querySelector(`.${node}`).offsetWidth
      const clientWidth = document.querySelector(`.${node}`).parentNode.clientWidth
      if (offsetWidth <= clientWidth) {
        this.isShowTooltip = true
      } else {
        this.isShowTooltip = false
      }
    },
    async updateSelect(val) {
      _.map(val, async (item) => {
        const attributeList = await this.getOpenAtrrOptions(item.classId)
        this.directoryConfigData[this.currentIndex].tableData.push({
          classId: item.classId,
          breakdownClassattributeId: item.classAttributeId,
          classList: this.entityOptions, // 实体列表
          attributeList, // 属性列表
          referenceClassName: item.referenceClassName, // 引用实体
          referenceClassId: item.referenceClassId,
          displayClassattributeId: '', // 显示属性
          relevancyClassAttributeId: '', // 关联属性
          mapParentClassId: '', // 关联上级实体
          mapParentClassList: [], // 关联上级实体列表
        })
        if (
          this.directoryConfigData[this.currentIndex].tableData.length ===
          this.dialogForm.ids.length + val.length
        ) {
          this.checkClassId(this.currentIndex)
          _.map(this.directoryConfigData[this.currentIndex].tableData, (item2, index2) => {
            if (item2.breakdownClassattributeId) {
              this.changeOpenAtrrs(item2, this.currentIndex, index2)
            }
          })
        }
      })
      this.dialogForm.visiable = false
    },
    // 修改按实体展开
    changeIsByClassType(i, isByClassType) {
      if (isByClassType) {
        let flag = false
        _.map(this.directoryConfigData, (item, index) => {
          if (item.isByClassType && index !== i) {
            flag = true
          }
        })
        if (flag) {
          this.$message.warning(this.$t('onlyOneCanBeExpandedByEntity'))
          this.$set(this.directoryConfigData[i], 'isByClassType', false)
        }
      }
    },
    // 修改实体
    async changeClassId(row, index, i, flag) {
      if (row.classId) {
        const classIdList = Object.keys(this.attributeObj)
        if (!classIdList.includes(row.classId)) {
          await new Promise((resolve) => {
            this.getOpenAtrrOptions(row.classId).then((result) => {
              this.attributeObj[row.classId] = result
              resolve()
            })
          })
        }
        this.$set(
          this.directoryConfigData[index].tableData[i],
          'attributeList',
          this.attributeObj[row.classId]
        )
        this.$set(
          this.directoryConfigData[index].tableData[i],
          'displayClassAttributeList',
          this.attributeObj[row.classId]
        )
        if (flag) this.checkClassId(index)
      }
    },
    // 校验实体
    checkClassId(index) {
      // 已经选择过的实体，无法选择
      const selectList = _.map(this.directoryConfigData[index].tableData, (item) => {
        return item.classId
      })
      _.map(this.directoryConfigData[index].tableData, (item) => {
        const selectOneList = _.filter(selectList, (selectItem) => {
          return selectItem !== item.classId
        })
        const classList = _.cloneDeep(this.entityOptions)
        _.map(item.classList, (cItem, cIndex) => {
          if (_.includes(selectOneList, cItem.id)) {
            classList[cIndex].disabled = true
          } else {
            classList[cIndex].disabled = false
          }
        })
        item.classList = classList
        return item
      })
      // 下级选择的实体上级存在，关联属性和关联上级实体无法选择
      if (index > 0) {
        const selectClassList = _.map(this.directoryConfigData[index - 1].tableData, (item) => {
          return item.classId
        })
        _.map(this.directoryConfigData[index].tableData, (item) => {
          if (_.includes(selectClassList, item.classId)) {
            item.relationDisabled = true
          }
          return item
        })
      }
    },
    // 新增属性
    addProperties(index) {
      if (this.assetForm.standardId === '' || this.assetForm.standardId === null) {
        this.$message.warning(this.$t('selectTheCriteriaFirst'))
        return
      }
      this.currentIndex = index
      this.dialogForm.standardId = this.assetForm.standardId
      this.dialogForm.ids = _.map(this.directoryConfigData[index].tableData, (item) => {
        return item.classId
      })
      this.dialogForm.visiable = true
    },
    // 批量删除层级
    batchDelHierarchies() {
      const checkList = _.filter(this.directoryConfigData, (item) => {
        return item.checked
      })
      const seqNos = checkList.map((t) => {
        return t.seqNo
      })
      if (seqNos.includes(1)) {
        this.$message.warning('目录1不可删除')
        return
      }
      console.log(checkList, seqNos, 'checkList')
      if (checkList.length === 0) {
        this.$message.warning(this.$t('selectHierarchyWantToDelete'))
        return
      }
      checkList.reverse() // 翻转数组元素，从大到小开始删除关联上级实体
      _.map(checkList, (item) => {
        this.directoryConfigData.splice(item.seqNo - 1, 1)
      })
    },
    // 添加层级
    addHierarchies() {
      this.activeNames.push(this.directoryConfigData.length)
      const classList = _.map(this.entityOptions, (item) => {
        return {
          id: item.id,
          name: item.name,
          disabled: false,
        }
      })
      // 关联上级实体列表的数据源是上一级目录选择的实体
      let mapParentClassList = []
      if (this.directoryConfigData.length >= 1) {
        const idList = _.map(
          this.directoryConfigData[this.directoryConfigData.length - 1].tableData,
          (item) => {
            return item.classId
          }
        )
        mapParentClassList = _.filter(this.entityOptions, (item2) => {
          return _.includes(idList, item2.id)
        })
      }
      this.directoryConfigData.push({
        seqNo: this.directoryConfigData.length + 1,
        checked: false,
        isByClassType: false, // 按类型展开
        withhierarchy: false, // 是否递归
        tableData: [
          {
            id: 1,
            index: '1',
            classId: '', // 实体
            classList, // 实体列表
            breakdownClassattributeId: '', // 属性
            attributeList: [],
            referenceClassName: '', // 引用实体
            referenceClassId: '',
            displayClassattributeId: '', // 显示属性
            relevancyClassAttributeId: '', // 关联属性
            mapParentClassId: '', // 关联上级实体
            mapParentClassList, // 关联上级实体列表
          },
        ],
      })
    },
    // 删除层级(单个)
    delHierarchies(index) {
      this.directoryConfigData.splice(index, 1)
      this.activeNames = this.activeNames.filter((item) => {
        return item !== index
      })
    },
    // 获取类别类型列表
    async getTypeList() {
      const parameter = {
        standard_id: this.assetForm.standardId,
      }
      const res = await StdClassTypeService.list(parameter)
      if (res && res.code === 0 && res.data) {
        this.typeClassList = res.data
      }
    },
    // 获取业务数据类型
    async getDataKind() {
      const res = await assetService.getDataKind()
      if (res && res.code === 0) {
        this.dataKindList = res.data
      }
    },
    isShowLeft() {
      this.showLeft = !this.showLeft
      if (this.showLeft) {
        document.getElementById('leftCol').className = 'el-col el-col-5 h-full'
        document.getElementById('rightCol').className = 'el-col el-col-14 h-full'
      } else {
        document.getElementById('leftCol').className = 'el-col el-col-0'
        document.getElementById('rightCol').className = 'el-col el-col-19 h-full'
      }
    },
    // 全选
    checkAll(val) {
      _.map(this.editableTabs, (item) => {
        item.checked = val
        return item
      })
    },
    // 单选
    checkOne() {
      const checkList = _.filter(this.editableTabs, (item) => {
        return item.checked
      })
      if (checkList.length === this.editableTabs.length) {
        this.checked = true
      } else {
        this.checked = false
      }
    },
    clickItem(val) {
      this.currentConfig = val
      this.currentTreeName = val.name
      this.currentTreeId = val.id
      this.attributeObj = this.$options.data().attributeObj
    },
    async loadNode(node, resolve) {
      if (node.level > 0) {
        const res = await assetService.getLazyTreeDatas(node.data.object)
        if (res && res.code === 0 && res.data) {
          return resolve(res.data)
        }
        return resolve([])
      }
      return resolve([])
    },
    handleAdd(i, index) {
      // 已经选择过的实体，无法选择
      const selectList = _.map(this.directoryConfigData[i].tableData, (item) => {
        return item.classId
      })
      const classList = _.cloneDeep(this.entityOptions)
      _.map(classList, (item) => {
        if (_.includes(selectList, item.id)) {
          item.disabled = true
        }
        return item
      })
      this.directoryConfigData[i].tableData.splice(index + 1, 0, {
        breakdownClassattributeId: '',
        displayClassattributeId: '',
        classId: '',
        referenceClassId: '',
        referenceClassName: '',
        relevancyClassAttributeId: '', // 关联属性
        mapParentClassId: '', // 关联上级实体
        classList,
        mapParentClassList: this.directoryConfigData[i].tableData[index].mapParentClassList,
      })
    },
    handleDelete(i, index) {
      if (this.directoryConfigData[i].tableData.length > 1) {
        this.$confirm(this.$t('deleteDataConfirm'), this.$t('tip'), {
          confirmButtonText: this.$t('confirm'),
          cancelButtonText: this.$t('cancel'),
          type: 'warning',
        })
          .then(() => {
            this.directoryConfigData[i].tableData.splice(index, 1)
            this.$message({
              type: 'success',
              message: this.$t('DeleteSuccessful'),
            })
          })
          .catch(() => {})
        return
      }
      this.$message({
        message: this.$t('keepAtLeastOneConfigurationDetail'),
        type: 'warning',
      })
    },
    // 获取资产目录树种类集合
    async getTreeKinds(type) {
      this.loading = true
      const params = {}
      params['name[$text]'] = this.keyWord
      const res = await assetService.getTreeKinds(params)
      this.loading = false
      if (res && res.code === 0 && res.data.length > 0) {
        this.editableTabs = _.map(res.data, (item) => {
          item.checked = false
          return item
        })
        if (type === 'refrech') {
          this.currentConfig = this.editableTabs[0]
          this.currentTreeName = this.editableTabs[0].name
          this.currentTreeId = this.editableTabs[0].id
        }
        // this.getTreeData()
      } else {
        this.editableTabs = []
        this.treeData = []
        this.currentConfig = {}
        this.currentTreeId = '0'
        this.currentTreeName = ''
        this.assetForm = this.$options.data().assetForm
        this.tableData = []
      }
    },
    // 根据id获取tree数据
    async getTreeData() {
      const treeHeigh = document.getElementById('tree')
      if (treeHeigh && treeHeigh.offsetHeight > 0) {
        this.heightObj.maxHeight = `${treeHeigh.offsetHeight / 16}rem`
      }
      this.treeLoading = true
      if (this.currentTreeId === '0' || this.currentTreeId === '') return
      const params = {
        structureBreakdownId: this.currentTreeId,
        skipCount: this.pageNo - 1,
        maxResultCount: this.pageSize,
        sorting: '',
      }
      const resTree = await assetService.getFirstTreeById(params)
      if (resTree && resTree.code === 0 && resTree.data) {
        // withhierarchy = 1 不请求下一级菜单
        this.treeData = resTree.data
        // this.treeData = _.map(resTree.data, (item) => {
        //   item.isLeaf = item.withhierarchy === 1
        //   return item
        // })
        this.treeLoading = false
        if (this.pageNo === 1 && resTree.totalCount > 100) {
          const res = await assetService.getFirstTreeById({
            structureBreakdownId: this.currentTreeId,
            skipCount: this.pageNo - 1,
            maxResultCount: resTree.totalCount,
            sorting: '',
          })
          if (res && res.code === 0 && res.data) {
            this.treeData = res.data
            // this.treeData = _.map(res.data, (item) => {
            //   item.isLeaf = item.withhierarchy === 1
            //   return item
            // })
          }
        }
        return
      }
      this.treeLoading = false
    },
    // 获取标准下拉列表数据
    async getStdStandardList() {
      const res = await assetService.getStdStandardList({})
      if (res && res.code === 0 && res.data) {
        this.standardOptions = res.data
      }
    },
    // 获取实体下拉列表数据
    async getClassList(isMainData, dataMainTypeId) {
      const res = await assetService.getClassAndClassTypeDropDowData({
        standardId: this.assetForm.standardId,
        skipCount: 0,
        maxResultCount: 999,
        sorting: '',
        nameOrCode: '',
        isMainData, // 是否主数据
        dataMainTypeId, // 主数据类型ID
      })
      if (res && res.code === 0 && res.data) {
        this.entityOptions = res.data
        const classList = _.map(this.entityOptions, (item) => {
          return {
            id: item.id,
            name: item.name,
            disabled: false,
          }
        })
        _.map(this.directoryConfigData, (item, index) => {
          _.map(item.tableData, (item2, index2) => {
            this.$set(this.directoryConfigData[index].tableData[index2], 'classList', classList)
          })
        })
      }
    },
    // 获取数据标签下拉列表数据
    async getDataLabelList() {
      const parameter = {
        Name: '',
        Code: '',
        SkipCount: 1,
        MaxResultCount: 999,
      }
      const res = await dataLabelManagementService.list(parameter)
      if (res && res.code === 0 && res.data) {
        this.dataLabelOptions = res.data
      }
    },
    // 获取实体归集下拉列表数据
    async getClassNotionalpoolingList() {
      const res = await assetService.getStdClassNotionalpooling({
        maxResultCount: 999,
        skipCount: 0,
        sorting: '',
        name: '',
        standardId: this.standardId,
      })
      if (res && res.code === 0 && res.data) {
        this.classNotionalpoolingOPtions = res.data
      }
    },
    // 获取属性下拉列表数据
    async getOpenAtrrOptions(classId) {
      const res = await assetService.getClassAndClassTypeAttrDropDowData({
        classId,
        skipCount: 0,
        maxResultCount: 999,
        sorting: '',
        nameOrCode: '',
      })
      if (res && res.code === 0 && res.data) {
        return res.data
      }
      return []
    },
    // 展开属性切换操作
    async changeOpenAtrrs(row, index, i) {
      if (row.breakdownClassattributeId) {
        _.map(row.attributeList, (item) => {
          if (row.breakdownClassattributeId === item.id) {
            this.directoryConfigData[index].tableData[i].referenceClassName =
              item.referenceClassName
            this.directoryConfigData[index].tableData[i].referenceClassId = item.referenceClassId
          }
        })
      } else {
        this.$set(this.directoryConfigData[index].tableData[i], 'displayClassAttributeList', [])
        this.directoryConfigData[index].tableData[i].displayClassattributeId = ''
        this.directoryConfigData[index].tableData[i].referenceClassName = ''
        this.directoryConfigData[index].tableData[i].referenceClassId = ''
      }
    },
    // 新增树种类
    addTreeItem() {
      this.isAddOpr = true
      this.assetForm.id = ''
      // this.directoryConfigData = this.$options.data().directoryConfigData
      this.setTreeItem()
      this.openAtrrOptions = []
    },
    // 删除树种类(批量删除)
    deleteTree() {
      const checkList = []
      _.map(this.editableTabs, (item) => {
        if (item.checked) checkList.push(item.id)
      })
      if (checkList.length > 0) {
        this.$confirm(this.$t('deleteDataConfirm'), this.$t('tip'), {
          confirmButtonText: this.$t('confirm'),
          cancelButtonText: this.$t('cancel'),
          type: 'warning',
        })
          .then(async () => {
            const res = await assetService.deleteTreeKinds({
              // data: [this.currentTreeId],
              data: checkList,
            })
            if (res && res.code === 0) {
              this.$message({
                type: 'success',
                message: this.$t('deleteSuccess'),
                duration: 2000,
              })
              this.getTreeKinds('refrech')
            }
          })
          .catch(() => {})
      } else {
        this.$message.warning(this.$t('pleaseSelectTheDataYouWantToDelete'))
      }
    },
    // 设置默认配置树子层级的tab列表
    setTreeItem() {
      this.$refs.assetForm.resetFields()
      this.assetForm = this.$options.data().assetForm
      // _.map(this.dataKindList, (item) => {
      //   if (item.item2 === '业务数据') {
      //     this.assetForm.dataKind = item.item1
      //   }
      // })
      // this.addRow()
      this.directoryConfigData = this.$options.data().directoryConfigData
    },
    // 初始化默认tree行
    addRow(quickvalue) {
      if (!quickvalue) {
        this.tableData = []
        const newrow = {
          breakdownClassattributeId: '',
          displayClassattributeId: '',
          seqNo: '',
          referenceClassId: '',
          referenceClassName: '',
          withhierarchy: false,
          displayClassAttributeList: [],
        }
        this.tableData.push(newrow)
      }
    },
    // 保存操作
    saveTreeTab() {
      this.$refs.assetForm.validate(async (valid) => {
        if (valid) {
          // 校验table必填项
          let outSideIndex
          let insideIndex
          // 1.实体必填
          let classIdFlag = false
          _.map(this.directoryConfigData, (item, index) => {
            _.map(item.tableData, (item2, index2) => {
              if (item2.classId === '' || item.classId === null) {
                classIdFlag = true
                outSideIndex = index
                insideIndex = index2
              }
            })
          })
          if (classIdFlag) {
            this.$message.warning(`第${outSideIndex + 1}级目录的第${insideIndex + 1}条实体不能为空`)
            return
          }
          // 2.属性必填
          let attributeIdFlag = false
          _.map(this.directoryConfigData, (item, index) => {
            _.map(item.tableData, (item2, index2) => {
              if (
                item2.breakdownClassattributeId === '' ||
                item.breakdownClassattributeId === null
              ) {
                attributeIdFlag = true
                outSideIndex = index
                insideIndex = index2
              }
            })
          })
          if (attributeIdFlag) {
            this.$message.warning(`第${outSideIndex + 1}级目录的第${insideIndex + 1}条属性不能为空`)
            return
          }
          // 3.一级选择递归后，如果新增了下级，下级(只有二级)必须要选择关联上级实体
          // 如果选择的实体中存在未引用自身的实体，则无法开启，并提示：需引用自身的实体才能开启递归 todo（后端有校验）
          if (this.directoryConfigData.length > 1 && this.directoryConfigData[0].withhierarchy) {
            let withhierarchyFlag = false
            _.map(this.directoryConfigData, (item, index) => {
              if (item.seqNo === 2) {
                _.map(item.tableData, (item2, index2) => {
                  if (item2.mapParentClassId === '' || item.mapParentClassId === null) {
                    withhierarchyFlag = true
                    outSideIndex = index
                    insideIndex = index2
                  }
                })
              }
            })
            if (withhierarchyFlag) {
              this.$message.warning(
                `第${outSideIndex + 1}级目录的第${insideIndex + 1}条关联上级实体不能为空`
              )
              return
            }
          }
          // 4.下级选择的实体上级不存在，关联属性和关联上级实体就必填；下级选择的实体上级存在，关联属性和关联上级实体无法选择；
          if (this.directoryConfigData.length > 1) {
            let relevancyFlag = false
            let mapParentFlag = false
            _.map(this.directoryConfigData, (item, index) => {
              if (index > 0) {
                const selectList = _.map(this.directoryConfigData[index - 1].tableData, (item2) => {
                  return item2.classId
                })
                _.map(item.tableData, (item3, index3) => {
                  if (
                    !_.includes(selectList, item3.classId) &&
                    (item3.relevancyClassAttributeId === '' ||
                      item3.relevancyClassAttributeId === null)
                  ) {
                    relevancyFlag = true
                    outSideIndex = index
                    insideIndex = index3
                  }
                  if (
                    !_.includes(selectList, item3.classId) &&
                    (item3.mapParentClassId === '' || item3.mapParentClassId === null)
                  ) {
                    mapParentFlag = true
                    outSideIndex = index
                    insideIndex = index3
                  }
                })
              }
            })
            if (relevancyFlag) {
              this.$message.warning(
                `第${outSideIndex + 1}级目录的第${insideIndex + 1}条关联属性不能为空`
              )
              return
            }
            if (mapParentFlag) {
              this.$message.warning(
                `第${outSideIndex + 1}级目录的第${insideIndex + 1}条关联上级实体不能为空`
              )
              return
            }
          }
          this.isLoadTable = true
          const params = _.cloneDeep(this.assetForm)
          const structureBreakdownDetails = []
          _.map(this.directoryConfigData, (item, index) => {
            _.map(item.tableData, (item2) => {
              structureBreakdownDetails.push({
                seqNo: index + 1,
                withhierarchy: item.withhierarchy ? 1 : 0,
                isByClassType: item.isByClassType,
                classId: item2.classId,
                breakdownClassattributeId: item2.breakdownClassattributeId,
                referenceClassId: item2.referenceClassId,
                referenceClassName: item2.referenceClassName,
                displayClassattributeId: item2.displayClassattributeId,
                relevancyClassAttributeId: item2.relevancyClassAttributeId,
                mapParentClassId: item2.mapParentClassId,
              })
            })
          })
          params.structureBreakdownDetails = structureBreakdownDetails
          let res
          this.saveTreeTabLoading = true
          if (this.isAddOpr) {
            res = await assetService.addTreeKinds({
              model: params,
            })
          } else {
            res = await assetService.updateTreeKinds({
              model: params,
            })
          }
          this.saveTreeTabLoading = false
          if (res && res.code === 0) {
            this.$message({
              type: 'success',
              message: this.$t('saveSuccessFul'),
              duration: 2000,
              onClose: async () => {
                await this.getTreeKinds('refrech')
                await this.getTreeData()
                if (this.isAddOpr) {
                  // 如果是新增
                  this.currentTreeId = res.data.id
                } else {
                  await this.getTreeKindDetail(this.currentTreeId)
                }
                this.isLoadTable = false
              },
            })
          } else {
            this.isLoadTable = false
          }
        }
      })
    },
    // 标准改变事件
    standardChange(val) {
      this.assetForm.classId = ''
      if (val) {
        this.getClassList()
      }
    },
    // 获取右侧的目录树配置数据
    async getTreeKindDetail(val) {
      const res = await assetService.getTreeKinds({
        id: val || this.currentTreeId,
      })
      if (res && res.code === 0) {
        _.forIn(this.assetForm, (val, key) => {
          this.assetForm[key] = res.data[key]
          this.assetForm.flag = `${this.assetForm.flag}`
        })
        const list = []
        this.classIdList = []
        for (let i = 0; i < res.data.structureBreakdownDetails.length; i = i + 1) {
          const element = res.data.structureBreakdownDetails[i]
          this.classIdList.push(element.classId)
          const index = _.findIndex(list, (item) => {
            return item.seqNo === element.seqNo
          })
          if (index === -1) {
            const obj = {}
            obj.seqNo = element.seqNo
            obj.checked = false
            obj.isByClassType = element.isByClassType
            obj.withhierarchy = element.withhierarchy === 1
            obj.tableData = []
            delete element.seqNo
            delete element.isByClassType
            delete element.withhierarchy
            obj.tableData.push(element)
            list.push(obj)
          } else {
            delete element.seqNo
            delete element.isByClassType
            delete element.withhierarchy
            list[index].tableData.push(element)
          }
        }
        list.sort((a, b) => {
          return a.seqNo - b.seqNo
        })
        this.directoryConfigData = _.cloneDeep(list)
        if (this.assetForm.standardId) await this.getClassList()
        this.assetForm.isMainData = this.assetForm.dataKind === 2
        // if (this.assetForm.dataKind) await this.dataKindChange(this.assetForm.dataKind)
        if (this.assetForm.dataMainTypeId) await this.dataKindChange(this.assetForm.dataMainTypeId)
        this.classIdList = _.uniq(this.classIdList) // classId去重
        _.map(this.classIdList, async (cItem) => {
          this.attributeObj[cItem] = await this.getOpenAtrrOptions(cItem)
          if (Object.keys(this.attributeObj).length <= this.classIdList.length) return
          _.map(this.directoryConfigData, async (item, index) => {
            this.checkClassId(index)
            _.map(item.tableData, async (item2, index2) => {
              if (item2.classId) {
                this.$set(
                  this.directoryConfigData[index].tableData[index2],
                  'attributeList',
                  this.attributeObj[item2.classId]
                )
                this.$set(
                  this.directoryConfigData[index].tableData[index2],
                  'displayClassAttributeList',
                  this.attributeObj[item2.classId]
                )
              }
              if (item2.breakdownClassattributeId) {
                this.changeOpenAtrrs(item2, index, index2)
              }
              if (index === 0) {
                item2.mapParentClassList = []
              } else {
                const idList = _.map(this.directoryConfigData[index - 1].tableData, (tItem) => {
                  return tItem.classId
                })
                item2.mapParentClassList = _.filter(this.entityOptions, (eItem) => {
                  return _.includes(idList, eItem.id)
                })
              }
              return item2
            })
            return item
          })
        })
      }
    },
    // 实体改变事件
    classChange() {
      this.assetForm.classNotionalpoolingId = ''
      this.assetForm.dataLabelId = ''
      _.forEach(this.tableData, (val) => {
        val.breakdownClassattributeId = ''
        val.displayClassattributeId = ''
        val.referenceClassId = ''
        val.referenceClassName = ''
      })
    },
  },
  watch: {
    'assetForm.classTypeId': {
      handler(newVal) {
        if (newVal) {
          this.getClassList()
        }
      },
    },
    // 'assetForm.standardId': {
    //   handler(val) {
    //     if (val) {
    //       this.getTypeList()
    //       this.isDisabled = false
    //       this.getClassList()
    //       return false
    //     }
    //     this.isDisabled = true
    //   },
    // },
    // 'assetForm.classId': {
    //   handler(val) {
    //     if (val) {
    //       this.getOpenAtrrOptions(val)
    //       this.getClassNotionalpoolingList(val)
    //     }
    //   },
    // },
    async currentTreeId(val) {
      if (val !== '0') {
        this.isAddOpr = false
        this.getTreeData()
        this.getTreeKindDetail(val)
      }
    },
  },
}
</script>

<style lang="scss" scoped>

.content {
  .leftTree {
    width: 20%;
    /deep/.el-tabs__content {
      height: 95% !important;
      overflow: auto !important;
      /deep/.el-tree {
        /deep/.el-tree-node__loading-icon {
          display: none !important;
        }
        .el-tree-node > .el-tree-node__children {
          overflow: inherit;
        }
      }
    }
    /deep/.el-tabs__nav-next,
    /deep/.el-tabs__nav-prev {
      line-height: 34px !important;
      font-size: 20px;
      color: #1682e6;
    }
  }
  .rightList {
    width: calc(70% - 20px);
    box-sizing: border-box;
    /deep/.el-table .cell {
      overflow: inherit !important;
    }
    /deep/.el-table__body-wrapper {
      // height: calc(100% - 365px);
      overflow-y: auto;
      /deep/.el-input-number {
        width: 140px;
      }
    }
  }
  /deep/.el-tabs__content {
    height: 74vh !important;
    position: relative;
    .pagination-box {
      position: absolute;
      bottom: 0;
      left: 10px;
    }
  }
  /deep/ .cell-center {
    display: table-cell;
    vertical-align: inherit;
  }
}
.multipane-resizer:before {
  content: '';
  position: absolute;
  top: 50%;
  left: 100%;
  width: 6px;
  height: 45px;
  border-left: 2px solid #d2d2d2;
  border-right: 2px solid #d2d2d2;
  transform: translate(-50%, -50%);
}

.multipane-resizer:hover:before {
  border-color: #999;
}
/deep/.el-card__header {
  padding: 10px !important;
}
.active {
  background: var(--tableSelectColor);
}
.text-overflow {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.title {
  /deep/.el-checkbox__label {
    font-weight: 700;
  }
}
.icon-bg-circleLeft:before {
  color: var(--buttonPrimaryBg);
}
.icon-bg-circleRight:before {
  color: var(--buttonPrimaryBg);
}
.toLeft {
  position: absolute;
  top: 50%;
  right: 0;
  display: flex;
  justify-content: center;
  align-items: center;
}
.toRight {
  position: absolute;
  top: 50%;
  left: 0;
  display: flex;
  justify-content: center;
  align-items: center;
}
.flex-center {
  display: flex;
  justify-content: center;
  align-items: center;
}

</style>
